window.addEventListener('message', function(event) {
  if (!event.data || event.data.source !== 'dialmaker-designer') return;
  if (event.data.type !== 'DIALMAKER_ADD_TO_CART') return;

  var payload = event.data.payload;
  var properties = payload.properties || {};

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: 56777007890818,
      quantity: 1,
      properties: properties
    })
  })
  .then(function(res) { return res.json(); })
  .then(function() {
    window.location.href = '/cart';
  })
  .catch(function(err) {
    console.error('Dialmaker cart error:', err);
  });
});
